import CreditCardLogos from './CreditCardLogos';

export default CreditCardLogos;
